export const seperators = {
  COLON: ':',
}
